import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=6be4bd2b&"
import script from "WX/components/topHeader.component?vue&type=script&lang=js&"
export * from "WX/components/topHeader.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports